import BaseXMLGenerator from './xlsx-tableexport-generator.js';
import AppDataSetting from '@/data/app-data-setting.js'

var XMLGenerator = new BaseXMLGenerator();
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
    var rows = []
    for (var data of datas) {
        var row = []

        let user = vm.$store.getters.users.find(o => o.ID == data.UserID) || { Profile: {} };
        let department = AppDataSetting.findUserDepartment(vm, user)

        let userPosition = (()=>{
            let level = AppDataSetting.findUserLevel(vm, user);
        
            if (level === 1) return "員工";
            if (level === 10) return "主管";
            if (level === 100) return "會計";
            if (level === 1000) return "總經理";
            if (level === 10000) return "蝦董";
            if (level === 100000) return "工程師";
            return level;
        })()

        let loan = (()=>{
            if (!data.LoanRecord) return "";
            if (data.LoanRecord.Offset > 0)
            return `多欠${data.LoanRecord.Offset}`;
            if (data.LoanRecord.Offset < 0)
            return `還${data.LoanRecord.Offset}`;
            return "";
        })()

        row.push(user.Profile.Name)
        row.push(department.Name)
        row.push(userPosition)
        row.push(loan)
        row.push(((data.LoanRecord && data.LoanRecord.Sum) ?'預支'+data.LoanRecord.Sum: ''))
        row.push(data.TotalTaskWorkingItemBonus + data.TotalWorkOrderBonus)
        row.push(data.Amount)
    
        rows.push(row)
    }
    let headerList = ['人員', '部門', '職稱', '當月績效', '績效紀錄', '當月獎金', '實發金額']
    return this.baseGenerate(rows, headerList)
}

export default XMLGenerator;